import React from 'react';
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { SECTION_KEYS } from '../utils/selectionUtils';
import { LABELS } from '../constants';

const styles = () => ({
  icon: {
    marginRight: 8,
  },
});

interface ViewProImagesButtonProps {
  onLoadProImages: () => void;
  onSelect: (key: string) => void;
  classes: { icon: string };
}

const ViewProImagesButton: React.FC<ViewProImagesButtonProps> = ({
  onLoadProImages,
  onSelect,
  classes,
}) => {
  const handleClick = () => {
    onLoadProImages();
    onSelect(SECTION_KEYS.PRO_IMAGES);
  };

  return (
    <Button variant="outlined" color="primary" size="small" onClick={handleClick}>
      <CloudDownloadIcon className={classes.icon} />
      {LABELS.VIEW_PRO_IMAGES}
    </Button>
  );
};

export default withStyles(styles)(ViewProImagesButton);
